import {
  Component,
  OnDestroy,
  ViewChild,
  OnInit,
  ViewContainerRef,
  Input,
  EventEmitter,
  Output,
} from "@angular/core";
import { SubSink } from "subsink";

import { ConfigurationService } from "@/shared-module/services";
import { Member, TeamTexts } from "@/core/models";
import { Configuration } from "@/shared-module/models";

@Component({
  selector: "app-memberlist",
  templateUrl: "memberlist.component.html",
})
export class MemberListComponent implements OnDestroy, OnInit {
  @ViewChild("template", { static: true }) template;
  @Input() members: Member[];
  @Input() texts: TeamTexts;
  @Output() addMemberClicked: EventEmitter<void> = new EventEmitter();
  @Output() lostPasswordClicked: EventEmitter<void> = new EventEmitter();
  @Output() updateMemberClicked: EventEmitter<number> = new EventEmitter();
  @Output() removeMemberClicked: EventEmitter<number> = new EventEmitter();
  subs = new SubSink();
  cssColor: string;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private configurationService: ConfigurationService,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.cssColor = c.cssColor;
      },
    );
  }

  addMember() {
    this.addMemberClicked.emit();
  }

  lostPassword() {
    this.lostPasswordClicked.emit();
  }

  updateMember(subUserId) {
    this.updateMemberClicked.emit(subUserId);
  }

  removeMember(subUserId) {
    this.removeMemberClicked.emit(subUserId);
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
